import { useReference } from "../../controllers/conductor";
import LoginController from "../../controllers/Login";
import { Button } from "../widgets/buttons";

import "../../styles/widgets/widgets.css";
import "../../styles/entry.css";

import bgvideo from "../../assets/videos/san_juanico.mp4";

export function Login() {

    const states = useReference({
        status: null,
        error: null
    });
    LoginController.states = states;

    /** @param {SubmitEvent} event */
    const onSubmit = (event) => {
        event.preventDefault();

        const { username: { value: username }, 
            password: { value: password } } = event.target.elements;

        LoginController.events.signIn(username, password);
    };

    const loggingIn = states.status === "loggingIn";

    return (<div className="entry-page">
        <div className="video-wrapper">
            <video autoPlay loop muted>
                <source src={bgvideo} type="video/mp4" />
            </video>
        </div>
        
        <div className="card-wrap">
            <div className="auth-card">
                <div className="logo" />
                <div className="pretitle">DEPARTMENT OF TOURISM REGION 8</div>
                <div className="title">Tourism Statistics Online<br/>Reporting System</div>
                <div className="tagline">With real-time data access, the possibilities<br/> for data-driven decisions are <b>infinite</b>.</div>
                { states.status === "error" ? <div className="error-strip">{states.error}</div> : "" }
                <form onSubmit={onSubmit}>
                    <input className="input" placeholder="Username" name="username" /><br />
                    <input className="input" placeholder="Password" name="password" type="password" /><br />
                    <Button className="login-btn" color="blue" inProgress={loggingIn}>{ loggingIn ? "LOGGING IN..." : "LOGIN" }</Button>
                </form>
                <Button className="secondary" onClick={() => LoginController.events.goToRegister()}>CREATE ACCOUNT</Button>
            </div>
        </div>
        
    </div>);
}